import { format } from "date-fns";
import type { InsightsQueryParams } from "@/types/insightsApi";
import type { InsightsReportsFilters } from "@/types/insightsReports";

/**
 * Converts UI filter state into the query params shape expected by the API.
 * Omits undefined/empty values so the URL stays clean.
 */
export function filtersToQueryParams(filters: InsightsReportsFilters): InsightsQueryParams {
  const params: InsightsQueryParams = {};

  if (filters.callDirection === "both") {
    params.directions = ["Inbound", "Outbound"];
  } else {
    params.directions = filters.callDirection === "inbound" ? ["Inbound"] : ["Outbound"];
  }

  if (filters.customerPhone.trim()) {
    params.customerPhone = filters.customerPhone.trim();
  }

  if (filters.taskQueues.length > 0) {
    params.queues = filters.taskQueues;
  }

  if (filters.departments.length > 0) {
    params.departments = filters.departments;
  }

  if (filters.agents.length > 0) {
    params.agents = filters.agents;
  }

  if (filters.startDate) {
    params.dateFrom = format(filters.startDate, "yyyy-MM-dd'T'HH:mm:ss");
  }

  if (filters.endDate) {
    params.dateTo = format(filters.endDate, "yyyy-MM-dd'T'HH:mm:ss");
  }

  return params;
}
